/**
 * QAQC - Represents Quality Assurance/Quality Control information for pay items.
 * Used to track major items, cost/time thresholds, and quality control requirements.
 */
export class QAQC {
  /** Major cost value threshold */
  MajorCostValue: number;

  /** Major time value threshold */
  MajorTimeValue: number;

  /** Indicates if this is a major item lookup */
  IsMajorItemLookup: boolean;

  /** Indicates if this is a major cost item */
  IsMajorCost: boolean;

  /** Indicates if this is a major time item */
  IsMajorTime: boolean;

  /** Indicates if cost checking is required */
  IsCheckCost: boolean;

  /** Indicates if sibling items are required */
  IsSiblingRequired: boolean;

  /** Count of past contracts */
  PastContractCount: number;

  /** Indicates if this is a common item */
  IsCommonItem: boolean;

  /** Element description */
  ElementDescription: string;

  /**
   * Creates a new QAQC instance
   * @param data - Object containing QAQC properties
   */
  constructor(data: {
    MajorCostValue: number;
    MajorTimeValue: number;
    IsMajorItemLookup: boolean;
    IsMajorCost: boolean;
    IsMajorTime: boolean;
    IsCheckCost: boolean;
    IsSiblingRequired: boolean;
    PastContractCount: number;
    IsCommonItem: boolean;
    ElementDescription: string;
  }) {
    this.MajorCostValue = data.MajorCostValue;
    this.MajorTimeValue = data.MajorTimeValue;
    this.IsMajorItemLookup = data.IsMajorItemLookup;
    this.IsMajorCost = data.IsMajorCost;
    this.IsMajorTime = data.IsMajorTime;
    this.IsCheckCost = data.IsCheckCost;
    this.IsSiblingRequired = data.IsSiblingRequired;
    this.PastContractCount = data.PastContractCount;
    this.IsCommonItem = data.IsCommonItem;
    this.ElementDescription = data.ElementDescription;
  }

  /**
   * Creates a QAQC from a plain object (useful for deserialization)
   * @param obj - Plain object with QAQC data
   * @returns New QAQC instance
   */
  static fromObject(obj: Partial<QAQC>): QAQC {
    return new QAQC({
      MajorCostValue: obj.MajorCostValue ?? 0,
      MajorTimeValue: obj.MajorTimeValue ?? 0,
      IsMajorItemLookup: obj.IsMajorItemLookup ?? false,
      IsMajorCost: obj.IsMajorCost ?? false,
      IsMajorTime: obj.IsMajorTime ?? false,
      IsCheckCost: obj.IsCheckCost ?? false,
      IsSiblingRequired: obj.IsSiblingRequired ?? false,
      PastContractCount: obj.PastContractCount ?? 0,
      IsCommonItem: obj.IsCommonItem ?? false,
      ElementDescription: obj.ElementDescription ?? "",
    });
  }

  /**
   * Converts the QAQC to a plain object (useful for serialization)
   * @returns Plain object representation
   */
  toObject(): Record<string, unknown> {
    return {
      MajorCostValue: this.MajorCostValue,
      MajorTimeValue: this.MajorTimeValue,
      IsMajorItemLookup: this.IsMajorItemLookup,
      IsMajorCost: this.IsMajorCost,
      IsMajorTime: this.IsMajorTime,
      IsCheckCost: this.IsCheckCost,
      IsSiblingRequired: this.IsSiblingRequired,
      PastContractCount: this.PastContractCount,
      IsCommonItem: this.IsCommonItem,
      ElementDescription: this.ElementDescription,
    };
  }
}


